// ============================================================================
// Cliente API para /api/turnos — módulo Personal (turnos de trabajadores).
// ============================================================================
import { api } from './client';

export interface Trabajador {
  id: number;
  nombre: string;
  rol: string;
  sede_id: number | null;
}

export interface Turno {
  id: number;
  sede_id: number;
  usuario_id: number;
  trabajador: string;
  trabajador_rol: string;
  fecha: string;        // YYYY-MM-DD
  hora_inicio: string;  // HH:MM[:SS]
  hora_fin: string;
  puesto: string | null;
  notas: string | null;
}

export interface TurnoInput {
  sede_id: number;
  usuario_id: number;
  fecha: string;
  hora_inicio: string;
  hora_fin: string;
  puesto?: string | null;
  notas?: string | null;
}

export const listTrabajadores = () =>
  api.get<Trabajador[]>('/api/turnos/trabajadores');

export const listTurnos = (q: { sede_id: number; desde?: string; hasta?: string }) => {
  const p = new URLSearchParams({ sede_id: String(q.sede_id) });
  if (q.desde) p.set('desde', q.desde);
  if (q.hasta) p.set('hasta', q.hasta);
  return api.get<Turno[]>(`/api/turnos?${p}`);
};

export const crearTurno = (input: TurnoInput) =>
  api.post<Turno>('/api/turnos', input);

export const actualizarTurno = (id: number, input: Partial<TurnoInput>) =>
  api.patch<Turno>(`/api/turnos/${id}`, input);

export const eliminarTurno = (id: number) =>
  api.del<{ ok: boolean }>(`/api/turnos/${id}`);
